import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ExamineeInfo } from 'features/irregularities';
import { Select, AlertMessage } from 'shared/components';
import * as irregularitiesActions from 'features/irregularities/duck';
import MaterialIcon from 'material-icons-react';
import { useTranslation, withTranslation } from 'react-i18next';
import uniqueId from 'lodash/uniqueId';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import './IrregularityExaminee.scss';

const orderRegsBy = '';

const mapExaminees = (examineesList) =>
  examineesList.map((element) => ({
    ...element,
    errors: {},
    idGenerated: uniqueId('ex-'),
  }));

const removeExistent = (list, addedExaminees, current) => {
  if (addedExaminees.length) {
    return list.filter(
      (ex) =>
        !addedExaminees.find((addedExam) =>
          current && !isEmpty(current)
            ? addedExam.regId === ex.id && addedExam.regId !== current.regId
            : addedExam.regId === ex.id
        )
    );
  }
  return list;
};

const mapRoomOptions = (rooms, t) => {
  const options = [];
  rooms.forEach((element) => {
    options.push({ value: element.id, label: element.name });
  });
  options.push({
    value: -1,
    label: t('common.labels.none'),
  });
  return options;
};

class IrregularityExaminee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      irregularity: props.irregularity,
      examineeModalOpen: false,
      currentExaminee: null,
      examinees: [],
      showSuccessMessage: false,
      successMessage: '',
    };

    this.onChange = this.onChange.bind(this);
    this.addExaminee = this.addExaminee.bind(this);
    this.removeExaminee = this.removeExaminee.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
  }

  componentDidMount() {
    const irregularity = this.props.irregularity;

    if (
      irregularity.irregularityRooms.length &&
      irregularity.irregularityRooms[0].roomId &&
      irregularity.irregularityRooms[0].roomId > 0
    ) {
      this.props.actions.getRoomRegs(irregularity.irregularityRooms[0].roomId, orderRegsBy);
    }

    if (!this.props.eventRegsOptions || !this.props.eventRegsOptions.length) {
      this.props.actions.getTcEventRegs(this.props.eventId, orderRegsBy);
    }

    this.setState({
      examinees:
        irregularity && irregularity.irregularityExaminees.length
          ? mapExaminees(irregularity.irregularityExaminees)
          : [],
      roomId:
        irregularity && irregularity.irregularityRooms.length
          ? irregularity.irregularityRooms[0].roomId
          : '',
    });
  }

  onChange(e) {
    const { value } = e.target;
    const irregularity = { ...this.state.irregularity };
    irregularity.irregularityRooms = [
      {
        roomId: +value,
      },
    ];

    this.setState({
      roomId: +value,
      irregularity,
    });

    if (value && +value > 0) {
      this.props.actions.getRoomRegs(value, orderRegsBy);
    } else {
      this.props.actions.getRoomRegsAction({ result: [] });
    }

    this.props.onChange(irregularity, { roomName: '' });
  }

  addExaminee(currentExaminee) {
    const { editFlag } = this.state;
    const irregularity = Object.assign({}, this.state.irregularity);
    let updatedExaminee = { ...currentExaminee };
    const examineesList = this.state.examinees;

    updatedExaminee.examineeNotifiedFlag = updatedExaminee.examineeNotifiedFlag || false;
    if (editFlag) {
      const examineeIdx = examineesList.findIndex(
        (ex) => ex.idGenerated === updatedExaminee.idGenerated
      );
      examineesList.splice(examineeIdx, 1, updatedExaminee);
    } else {
      const examinee = { ...updatedExaminee, idGenerated: uniqueId('ex-') };
      examineesList.push(examinee);
    }

    irregularity.irregularityExaminees = examineesList.map((examinee) =>
      omit(examinee, ['errors', 'idGenerated'])
    );

    this.setState({
      examinees: examineesList,
      irregularity,
    });

    this.toggleModal();
    this.props.onChange(irregularity, { examinees: '' });
    this.setState({
      showSuccessMessage: true,
      successMessage: editFlag
        ? 'irregularities.successEditExaminee'
        : 'irregularities.successAddExaminee',
    });
  }

  removeExaminee(examinee) {
    let newList = [...this.state.examinees];

    const examIdx = newList.findIndex((exam) => exam.idGenerated === examinee.idGenerated);
    newList.splice(examIdx, 1);

    this.setState({
      examinees: newList,
    });
    const { irregularity } = this.state;
    irregularity.irregularityExaminees = newList.map((examinee) =>
      omit(examinee, ['errors', 'idGenerated'])
    );

    this.props.onChange(irregularity, { examinees: '' });
    this.setState({
      showSuccessMessage: true,
      successMessage: 'irregularities.successRemoveExaminee',
    });
  }

  toggleModal(examinee) {
    const examineeNotFoundEnabled = examinee && !!examinee.idGenerated && !examinee.regId;

    this.setState((prevState) => ({
      currentExaminee: examinee,
      editFlag: !!examinee,
      examineeNotFoundEnabled: examineeNotFoundEnabled,
      showSuccessMessage: false,
      roomRosterSelectedFlag:
        examinee && !examineeNotFoundEnabled
          ? !!this.props.roomRegsOptions.find((ex) => ex.id === examinee.regId)
          : Boolean(this.state.roomId && this.state.roomId > 0),
      examineeModalOpen: !prevState.examineeModalOpen,
    }));
  }

  removeMessage() {
    this.setState({
      showSuccessMessage: false,
    });
  }

  render() {
    const {
      irregularity,
      examineeModalOpen,
      currentExaminee,
      editFlag,
      showSuccessMessage,
      successMessage,
      roomId,
      examineeNotFoundEnabled,
      roomRosterSelectedFlag,
    } = this.state;
    const { errors, eventRegsOptions, roomRegsOptions, hideMatchIdFlag } = this.props;

    return (
      <div>
        <section className="examinee-involvement">
          <Select
            className="select-room"
            options={mapRoomOptions(this.props.rooms, this.props.t)}
            value={roomId}
            name="roomName"
            label={this.props.t('common.labels.roomName')}
            onChange={this.onChange}
            disabled={this.props.disableRoom}
            errors={errors.roomName}
            emptyDefault
          />
          <h5 className="pt-3">
            {this.props.t('irregularities.examineeInvolvedTotalLabel', {
              total: this.state.examinees.length,
            })}
          </h5>
          {this.state.examinees.map((examinee, idx) => (
            <ExamineeDetails
              examinee={examinee}
              order={idx}
              key={`examinee-${idx}`}
              hideMatchIdFlag={hideMatchIdFlag}
              toggleModal={this.toggleModal}
              removeExaminee={this.removeExaminee}
            />
          ))}
          <div className="examinee-row">
            <button className="btn-link fw-bold" onClick={() => this.toggleModal()}>
              <MaterialIcon icon="control_point" size="tiny" />
              <span className="ps-1">{this.props.t('irregularities.addNewExamineeLabel')}</span>
            </button>
            {this.props.errors && this.props.errors.examinees && (
              <p className="text-error font-size-12 mb-0 mt-2 ps-3">
                {this.props.t(this.props.errors.examinees)}
              </p>
            )}
          </div>
          <ExamineeInfo
            examinee={currentExaminee}
            examineeModalOpen={examineeModalOpen}
            toggleModal={this.toggleModal}
            editFlag={editFlag}
            hideMatchIdFlag={hideMatchIdFlag}
            allowVoidFlag={irregularity.irregularityType.allowVoidFlag}
            onAddExaminee={this.addExaminee}
            examineeNotFoundEnabled={examineeNotFoundEnabled}
            roomSelectedFlag={roomRosterSelectedFlag}
            disabledRoomRosters={!(roomId && roomId > 0)}
            roomRegsOptions={removeExistent(
              roomRegsOptions,
              irregularity.irregularityExaminees,
              currentExaminee
            )}
            eventRegsOptions={removeExistent(
              eventRegsOptions,
              irregularity.irregularityExaminees,
              currentExaminee
            )}
          />
        </section>
        <AlertMessage
          show={showSuccessMessage}
          removeMessage={this.removeMessage}
          message={successMessage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    eventRegsOptions: state.irregularities.tcEventRegs,
    roomRegsOptions: state.irregularities.roomRegs,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...irregularitiesActions }, dispatch),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(IrregularityExaminee)
);

IrregularityExaminee.propTypes = {
  irregularity: PropTypes.shape({
    irregularityRooms: PropTypes.arrayOf(PropTypes.shape({})),
    irregularityExaminees: PropTypes.arrayOf(PropTypes.shape({})),
    irregularityType: PropTypes.shape({
      allowVoidFlag: PropTypes.bool,
    }),
  }).isRequired,
  eventId: PropTypes.string.isRequired,
  rooms: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  disableRoom: PropTypes.bool,
  errors: PropTypes.shape({
    roomName: PropTypes.arrayOf(PropTypes.string),
    examinees: PropTypes.string,
  }),
  hideMatchIdFlag: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  eventRegsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  roomRegsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  actions: PropTypes.shape({
    getRoomRegs: PropTypes.func.isRequired,
    getTcEventRegs: PropTypes.func.isRequired,
    getRoomRegsAction: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

const ExamineeDetails = (props) => {
  const { t } = useTranslation();
  return (
    <div className="examinee-row" key={`examinee-${props.order}`}>
      <div className="left-section">
        <p className="fw-bold mb-1">
          {props.examinee.lastName}, {props.examinee.firstName}
        </p>
        {!props.hideMatchIdFlag && <p className="mb-1">{props.examinee.matchId}</p>}
        <p>
          {props.examinee.voidDocumentFlag && <span>{t('irregularities.voidDocumentsLabel')}</span>}
          {props.examinee.examineeNotifiedFlag && (
            <span> - {t('irregularities.examineeNotifiedLabel')} </span>
          )}
        </p>
      </div>
      <div className="btn-container">
        <div>
          <button
            className="btn-link text-pacific-blue text-strong"
            onClick={() => props.toggleModal(props.examinee)}>
            <span className="fw-bold">
              <i className="fa fa-pencil" />
              {t('irregularities.editPerson')}
            </span>
          </button>
        </div>
        <div>
          <button
            className="btn-link text-pacific-blue text-strong"
            onClick={() => props.removeExaminee(props.examinee)}>
            <span className="fw-bold">
              <i className="fa fa-trash" />
              {t('common.labels.remove')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
